export interface Order {
  id: string;
  organizationId: string;
  organizationName: string;
  planType: 'individual_free' | 'individual_pro' | 'team_free' | 'team_pro' | 'enterprise_pro';
  amount: number;
  currency: 'USD' | 'CNY' | 'EUR';
  status: 'pending' | 'completed' | 'failed' | 'cancelled' | 'refunded';
  paymentMethod?: string;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
}

export const mockOrders: Order[] = [
  {
    id: 'order-1',
    organizationId: 'org-1',
    organizationName: 'Tech Innovations Inc.',
    planType: 'team_pro',
    amount: 299.99,
    currency: 'USD',
    status: 'completed',
    paymentMethod: 'Credit Card',
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-01-15T00:05:00Z',
    completedAt: '2024-01-15T00:05:00Z'
  },
  {
    id: 'order-2',
    organizationId: 'org-2',
    organizationName: 'Digital Marketing Agency',
    planType: 'team_free',
    amount: 0,
    currency: 'USD',
    status: 'completed',
    createdAt: '2024-01-05T00:00:00Z',
    updatedAt: '2024-01-05T00:01:00Z',
    completedAt: '2024-01-05T00:01:00Z'
  },
  {
    id: 'order-3',
    organizationId: 'org-3',
    organizationName: 'StartupCorp',
    planType: 'individual_pro',
    amount: 99.99,
    currency: 'USD',
    status: 'completed',
    paymentMethod: 'PayPal',
    createdAt: '2024-01-20T00:00:00Z',
    updatedAt: '2024-01-20T00:03:00Z',
    completedAt: '2024-01-20T00:03:00Z'
  },
  {
    id: 'order-4',
    organizationId: 'org-4',
    organizationName: 'Enterprise Solutions Ltd.',
    planType: 'enterprise_pro',
    amount: 999.99,
    currency: 'USD',
    status: 'pending',
    paymentMethod: 'Bank Transfer',
    createdAt: '2024-01-28T00:00:00Z',
    updatedAt: '2024-01-28T00:00:00Z'
  },
  {
    id: 'order-5',
    organizationId: 'org-5',
    organizationName: 'Creative Studio',
    planType: 'team_pro',
    amount: 299.99,
    currency: 'USD',
    status: 'failed',
    paymentMethod: 'Credit Card',
    createdAt: '2024-01-25T00:00:00Z',
    updatedAt: '2024-01-25T00:02:00Z'
  }
];

export const findOrderById = (id: string): Order | undefined => {
  return mockOrders.find(order => order.id === id);
};